import {
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild,
  Input,
} from '@angular/core';
import { PreguntasFrecuentesService } from '../../services/util/preguntas-frecuentes.service';
import {
  FiltroPreguntaDTO,
  PreguntaFrecuenteDTO,
} from '../../dto/preguntas-frecuentes/pregunta-frecuenteDTO';
import { DomSanitizer } from '@angular/platform-browser';
import { FormEditarPreguntasFrecuentesComponent } from '../forms/form-editar-preguntas-frecuentes/form-editar-preguntas-frecuentes.component';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from "../../services/util/language.service";
import { AlertaModalService } from '../../services/util/alerta-modal.service';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-preguntas-frecuentes',
  templateUrl: './preguntas-frecuentes.component.html',
  styleUrl: './preguntas-frecuentes.component.scss',
})
export class PreguntasFrecuentesComponent implements OnInit {
  @ViewChild(FormEditarPreguntasFrecuentesComponent)
  formularioPreguntasComponent!: FormEditarPreguntasFrecuentesComponent;
  @Input() mostrarIconoEditar = false;
  // Lista
  preguntas: PreguntaFrecuenteDTO[] = [];

  // String
  pregunta = '';
  preguntaText: any = {};
  // Catergorias
  categorias: Map<string, PreguntaFrecuenteDTO[]> = new Map();
  categoriasKeys: string[] = [];
  idiomaActual: string = 'es';
  orden: number = 0;
  constructor(
    private preguntasService: PreguntasFrecuentesService,
    private sanitizer: DomSanitizer,
    private cd: ChangeDetectorRef,
    private readonly translate: TranslateService,
    private languageService: LanguageService,
    private readonly alertService: AlertaModalService
  ) { }
  ngOnInit() {
    this.idiomaActual = this.languageService.getCurrentLanguage();
    this.languageService.currentLanguage$.subscribe(lang => {
      this.idiomaActual = lang;
      this.buscarPregunta();
    });
    combineLatest([
      this.translate.stream('preguntas'),
    ]).subscribe(([preguntasText]) => {
      // Procesar el texto de 'preguntas'
      for (const key of Object.keys(preguntasText)) {
        this.preguntaText[key] = preguntasText[key];
      }
    });
  }

  editarPregunta(pregunta: any) {
    if (this.formularioPreguntasComponent) {
      this.formularioPreguntasComponent.editarPreguntaFrecuente(pregunta);
    }
  }

  editarEstadoPregunta(pregunta: any) {
    this.alertService.confirmacion(this.preguntaText['seguro'], '',
      () => {
        this.preguntasService.editarEstadoPregunta(pregunta.Id).subscribe({
          next: async () => {
            await this.alertService.exito(this.preguntaText['exito_editar']);
            this.buscarPregunta();
          },
          error: async () => {
            await this.alertService.error(this.preguntaText['error_editar']);
          },
        });
      }, () =>{

      })

  }

  crearPregunta() {
    if (this.formularioPreguntasComponent) {
      this.formularioPreguntasComponent.crearPreguntaFrecuente(this.orden);
    }
  }

  // Función que lista las preguntas de acuerdo al filtro
  buscarPregunta() {
    const json: FiltroPreguntaDTO = {
      busqueda: this.pregunta,
      idioma: this.idiomaActual
    };
    this.preguntasService
      .listarPreguntas(json)
      .subscribe((resp: PreguntaFrecuenteDTO[]) => {
        const ordenMayor = Math.max(...resp.map(p => p.Orden ?? 0));
        this.orden = ordenMayor + 1;
        // this.preguntas = resp.map(pregunta => {
        //   pregunta.Respuesta = this.sanitizer.bypassSecurityTrustHtml(pregunta.Respuesta.toString())
        //   return pregunta
        // })
        this.preguntas = resp.map(pregunta => {
          // Asegurar que la respuesta es string
          const respuestaStr = pregunta.Respuesta?.toString() || '';

          // Modificar el contenido para que los <p> tengan color 4C4C4C
          const cuerpoConEstilo = respuestaStr.replace(
            /<p(.*?)>/g,
            '<p$1 style="color: #4C4C4C;">'
          );

          // Reasignar la respuesta estilizada
          pregunta.Respuesta = cuerpoConEstilo;

          const regex = /<a routerLink="(.*?)">(.*?)<\/a>/;
          const match = cuerpoConEstilo.match(regex);

          if (match) {
            const enlace = match[1];
            pregunta.esEnlace = true;
            pregunta.enlace = enlace;
            pregunta.textoEnlace = match[2];
            pregunta.Respuesta = this.sanitizer.bypassSecurityTrustHtml(
              cuerpoConEstilo.split('<a')[0]
            );
          } else {
            // Sanitizar si no hay <a>
            pregunta.Respuesta = this.sanitizer.bypassSecurityTrustHtml(cuerpoConEstilo);
          }

          return pregunta;
        });
        this.categorias.clear();
        this.preguntas.forEach(pregunta => {
          if (!this.categorias.has(pregunta.Categoria)) {
            this.categorias.set(pregunta.Categoria, []);
          }
          this.categorias.get(pregunta.Categoria)?.push(pregunta);
        });
        // Actualiza la propiedad con las llaves
        this.categoriasKeys = Array.from(this.categorias.keys());
      });
  }
}
